import React, { useEffect, useState } from "react";
import PresidentDetailsComponent from "./presidentDetails";
import "./presidentDetails.scss";
import { societyWingList } from "../../../redux/slice/societyWingListSlice";
import { societyFlatList } from "../../../redux/slice/societyFlatListSlice";
import { addPresident } from "../../../redux/slice/addPresidentSlice";
import { connect } from "react-redux";
import { Cookies } from "react-cookie";
import Notify from "../../common/notify/notify";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../../common/pageLoader";
import { presidentDetails } from "../../../redux/slice/presidentDetailsSlice";
import { societyDetails } from "../../../redux/slice/societyDetailsSlice";
import { presidentUpdate } from "../../../redux/slice/presidentUpdateSlice";

const PresidentDetails = (props) => {
  const {
    handelchangeInput,
    societyFlatListData,
    callsocietyWingListData,
    callsocietyFlatListData,
    calladdPresidentData,
    societyWingListData,
    addPresidentData,
    callpresidentDetailsData,
    callsocietyDetailsData,
    callpresidentUpdate,
    societyDetailsData,
    presidentDetailsData,
    presidentUpdateData,
  } = props;
  const cookies = new Cookies();
  const societyId = cookies.get("society_id");
  const { id } = useParams();

  const navigate = useNavigate();
  const wingName =
    (societyWingListData &&
      societyWingListData.societyWingListData &&
      societyWingListData.societyWingListData.data &&
      societyWingListData.societyWingListData.data.data) ||
    null;
  const flat_list =
    (societyFlatListData &&
      societyFlatListData.societyFlatListData &&
      societyFlatListData.societyFlatListData.data &&
      societyFlatListData.societyFlatListData.data.data) ||
    null;

  const wing_section = wingName?.map((item) => ({
    value: item.wingName,
  }));
  useEffect(() => {
    if (id) {
      callsocietyWingListData(id);
    } else {
      callsocietyWingListData(societyId);
    }
  }, [societyId, id]);
  const [validation, setValidation] = useState({});
  const [userError, setUserError] = useState({});
  const [societyWing, setSocietyWing] = useState(null);
  const [societyFlat, setSocietyFlat] = useState(null);
  const [presidentID, setPresidentID] = useState(null);
  const [addPresident, setAddPresident] = useState({
    name: "",
    code: "",
    phone_number: "",
    role: "",
    email: "",
    flat: "",
    wing: "",
    society: "",
    address: "",
    profile_image: "",
    wingName: "",
    flatName: "",
    gender: "",
  });
  let userSchema = Yup.object({
    name: Yup.string().required(
      "Please enter the president's name to proceed."
    ),
    phone_number: Yup.string().required(
      "Please enter your phone number to proceed."
    ),
    flatName: Yup.string().required(
      "Please select the flat number to proceed."
    ),
    wingName: Yup.string().required("Please select the Wing to proceed."),
    email: Yup.string()
      .required("Please enter your email address to proceed.")
      .email("Please enter a valid email address."),
    gender: Yup.string().required("Please select your gender to proceed."),
  });

  const handelAddPresident = (event) => {
    const { name, value } = event.target;

    setAddPresident((prevState) => ({
      ...prevState,
      [name]:
        name === "phone_number" || name === "pin_code"
          ? value === "" || /^[0-9]*$/.test(value)
            ? value === ""
              ? ""
              : Number(value)
            : prevState[name]
          : value,
    }));

    setUserError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleChangeWing = (value, name) => {
    const sicietyWing_id = wingName.find((client) => client.wingName === value);
    const clientId = sicietyWing_id ? sicietyWing_id.wingId : null;

    setAddPresident((prevState) => ({
      ...prevState,
      [name]: clientId,
      wingName: value,
    }));
    setUserError((prevState) => ({
      ...prevState,
      wingName: "",
    }));
    callsocietyFlatListData(clientId);
  };
  useEffect(() => {
    if (presidentID) {
      callsocietyFlatListData(societyWing);
    }
  }, [presidentID]);

  const handleChangeflat = (value, name) => {
    const sicietyflat_id = flat_list.find(
      (client) => client.flatNumber === value
    );
    const clientId = sicietyflat_id ? sicietyflat_id.flatId : null;

    setAddPresident((prevState) => ({
      ...prevState,
      [name]: clientId,
      flatName: value,
    }));
    setUserError((prevState) => ({
      ...prevState,
      flatName: "",
    }));
  };

  const handleChangeGender = (value) => {
    setAddPresident((prevState) => ({
      ...prevState,
      gender: value,
    }));
    setUserError((prevState) => ({
      ...prevState,
      gender: "",
    }));
  };

  const flat_section = flat_list?.map((item) => ({
    value: item.flatNumber,
  }));

  const handleComfirm = async () => {
    let error = {};
    if (!addPresident.name) {
      error.name = "Please Enter Name";
    }
    if (!addPresident.email) {
      error.email = "Please Enter email";
    }
    if (!addPresident.phone_number) {
      error.phone_number = "Please Enter phone Number";
    }
    if (!addPresident.flat) {
      error.flat = "Please select flat";
    }
    if (!addPresident.wing) {
      error.wing = "Please Select Wing";
    }
    if (!addPresident.gender) {
      error.gender = "Please Select Gender";
    }
    setValidation(error);
    try {
      const user = await userSchema.validate(addPresident, {
        abortEarly: false,
      });
    } catch (error) {
      const newError = {};
      error.inner.forEach((err) => {
        newError[err.path] = err.message;
      });
      setUserError(newError);
    }
    if (Object.keys(error).length === 0) {
      const finalData = {
        name: addPresident.name,
        phone_number: Number(`${addPresident.phone_number}`),
        email: addPresident.email,
        address: addPresident.address,
        role: "president",
        profile_image: "",
        society: societyId,
        wing: [addPresident.wing],
        flat: [addPresident.flat],
        code: String(addPresident.code),
        gender: addPresident.gender,
      };
      const confirmResult = await calladdPresidentData(finalData);
      if (confirmResult.type === "addPresident/fulfilled") {
        setAddPresident({
          name: "",
          code: "",
          phone_number: "",
          role: "",
          email: "",
          flat: "",
          wing: "",
          society: "",
          address: "",
          profile_image: "",
          gender: "",
        });
        navigate("/society-list");
        Notify("success", "The president has been added successfully.", "");
      }
      if (confirmResult.type === "addPresident/rejected") {
        Notify(
          "error",
          "Oops! Something went wrong. Please try again later.",
          ""
        );
      }
    }
  };

  const handleSocietyDetails = async () => {
    const result = await callsocietyDetailsData(id);
    if (result.type === "societyDetails/fulfilled") {
      const wingID = result.payload.data.data[0].president?.[0]?.wing?.[0]?._id;
      const flatId = result.payload.data.data[0].president?.[0]?.flat?.[0]?._id;

      const searSocietyData = result.payload.data?.data[0]?.president[0]?._id;
      setPresidentID(searSocietyData);
      setSocietyWing(wingID);
      setSocietyFlat(flatId);
    }
  };

  useEffect(() => {
    if (id) {
      handleSocietyDetails();
    }
  }, [id]);

  const handlePresidentDetails = async () => {
    const result = await callpresidentDetailsData(presidentID);
    if (result.type === "presidentDetails/fulfilled") {
      const searSocietyData = result.payload?.data[0];

      setAddPresident({
        name: searSocietyData?.name,
        email: searSocietyData?.email,
        phone_number: searSocietyData?.phone_number.toString().slice(2),
        president_id: searSocietyData?._id,
        flatName: searSocietyData?.flat,
        wingName: searSocietyData?.wing,
        wing: societyWing,
        flat: societyFlat,
        code: "",
        gender: searSocietyData?.gender || "",
      });
    }
  };
  useEffect(() => {
    if (presidentID) {
      handlePresidentDetails();
    }
  }, [presidentID]);

  const handelUpdatePresidentDetails = async () => {
    let error = {};
    if (!addPresident.name) {
      error.name = "Please Enter Name";
    }
    if (!addPresident.email) {
      error.email = "Please Enter email";
    }
    if (!addPresident.phone_number) {
      error.phone_number = "Please Enter phone Number";
    }
    if (!addPresident.flatName) {
      error.flatName = "Please select flat";
    }
    if (!addPresident.wingName) {
      error.wingName = "Please Select Wing";
    }
    if (!addPresident.gender) {
      error.gender = "Please Select Gender";
    }
    setUserError(error);

    if (Object.keys(error).length === 0) {
      const editedData = {
        presidentid: presidentID,
        presidentInfo: {
          name: addPresident.name,
          email: addPresident.email,
          phone_number: Number(
            presidentID
              ? `${addPresident.phone_number}`
              : `${addPresident.phone_number}`
          ),
          wing: [addPresident.wing],
          flat: [addPresident.flat],
          code: String(addPresident.code),
          role: "president",
          society: id,
          gender: addPresident.gender,
        },
      };
      const result = await callpresidentUpdate(editedData);
      if (result.type === "presidentUpdate/fulfilled") {
        Notify("success", "The changes have been updated successfully.", "");
        navigate("/society-list");
      }
      if (result.type === "presidentUpdate/rejected") {
        Notify(
          "error",
          "Oops! Something went wrong. Please try again later.",
          ""
        );
      }
    }
  };
  const loading =
    addPresidentData.isLoading ||
    societyDetailsData.isLoading ||
    presidentDetailsData.isLoading ||
    presidentUpdateData.isLoading;

  return (
    <>
      {loading && <PageLoader />}
      <PresidentDetailsComponent
        handelchangeInput={handelchangeInput}
        userError={userError}
        handelAddPresident={handelAddPresident}
        wing_section={wing_section}
        flat_section={flat_section}
        handleChangeWing={handleChangeWing}
        handleChangeflat={handleChangeflat}
        handleChangeGender={handleChangeGender}
        addPresident={addPresident}
        handleComfirm={handleComfirm}
        addPresidentData={addPresidentData.isLoading}
        presidentID={presidentID}
        handelUpdatePresidentDetails={handelUpdatePresidentDetails}
        id={id}
        presidentUpdateData={presidentUpdateData}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    societyWingListData: state.societyWingListData,
    societyFlatListData: state.societyFlatListData,
    addPresidentData: state.addPresidentData,
    presidentDetailsData: state.presidentDetailsData,
    societyDetailsData: state.societyDetailsData,
    presidentUpdateData: state.presidentUpdateData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    callsocietyWingListData: (data) => dispatch(societyWingList(data)),
    callsocietyFlatListData: (data) => dispatch(societyFlatList(data)),
    calladdPresidentData: (data) => dispatch(addPresident(data)),
    callpresidentDetailsData: (data) => dispatch(presidentDetails(data)),
    callsocietyDetailsData: (data) => dispatch(societyDetails(data)),
    callpresidentUpdate: (data) => dispatch(presidentUpdate(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PresidentDetails);
